"use client";
import {
  ErrorPage,
  ErrorPageButton,
  ErrorPageContent,
  ErrorPageIcon,
  ErrorPageSubtitle,
  ErrorPageTitle,
} from "@xenithlabs/xenith-ui";
import { useEffect } from "react";
import { Logger } from "../../logger";

interface BaseErrorPageProps {
  error?: Error;
  onReload?: () => void;
}
export const BaseErrorPage = ({ error, onReload }: BaseErrorPageProps) => {
  useEffect(() => {
    if (error) {
      Logger.error(error);
    }
  }, [error]);
  return (
    <div className="mt-[200px]">
      <ErrorPage>
        <ErrorPageIcon />
        <ErrorPageContent>
          <ErrorPageTitle>Oops something went wrong !</ErrorPageTitle>
          <ErrorPageSubtitle>
            An unexpected error occurred. Please refresh the page or contact our
            support.
          </ErrorPageSubtitle>
          <ErrorPageButton
            className="mt-2"
            onClick={() => {
              if (onReload) {
                onReload();
              }
              window.location.reload();
            }}
          >
            Refresh The Page
          </ErrorPageButton>
        </ErrorPageContent>
      </ErrorPage>
    </div>
  );
};
